import { Button, Form, Input, Space } from "antd";
import { descriptionRules, nameRules } from "common/FormValidationRules";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import { useEffect } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

const emptyObject = {};
const SchemaCloneForm = ({ schema, allowClone, onCloneSchemaModel, onValuesChanged, formErrors }) => {
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue(schema);
    }, [form, schema]);

    const onFormSubmit = (values) => {
        onCloneSchemaModel({ ...schema, ...values });
    };

    const getFormErrors = (fieldName) => {
        if (formErrors && formErrors[fieldName]) {
            return {
                help: formErrors[fieldName],
                validateStatus: "error",
            };
        }
        return emptyObject;
    };

    return (
        <Form
            initialValues={schema}
            form={form}
            name="basic"
            onFinish={onFormSubmit}
            onValuesChange={onValuesChanged}
            className="relative flex size-full flex-1 flex-col overflow-auto"
        >
            <FlexContainerLayout contentClassName="flex-row w-full gap-4">
                <div className="w-1/3 flex-none">
                    <Form.Item
                        {...getFormErrors("name")}
                        label="Schema Name"
                        name={["name"]}
                        validateFirst={true}
                        rules={nameRules}
                        style={{ marginBottom: "unset" }}
                    >
                        <Input data-testid={CypressTestIds.SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_NAME_INPUT} />
                    </Form.Item>
                </div>
                <div className="flex-auto">
                    <Space className="space-stretched-first-item w-full">
                        <Form.Item
                            {...getFormErrors("description")}
                            label="Schema Description"
                            name={["description"]}
                            rules={descriptionRules}
                            style={{ marginBottom: "unset" }}
                        >
                            <Input data-testid={CypressTestIds.SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_DESC_INPUT} />
                        </Form.Item>
                        <Button type="primary" htmlType="submit" disabled={!allowClone} data-testid={CypressTestIds.SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_CREATE_BUTTON}>
                            Clone
                        </Button>
                    </Space>
                </div>
            </FlexContainerLayout>
        </Form>
    );
};

export default SchemaCloneForm;
